<!-- eslint-disable vue/no-deprecated-v-bind-sync -->
<template>
  <div>
    <!-- iteration in the component to generate multiple form -->
    <v-row
      v-if="showConditionInfo"
      align-content="center" justify="space-around" class="my-3">
      <v-alert type="info" >
        <div class="mb-2">
          Lorsqu’une boutique est administrée dans une condition, il n’est plus possible d’ajouter d’autres filtres dans une même condition ou d’administrer une autre condition
        </div>
     </v-alert>
    </v-row>
    <v-card
      v-for="(conditionValue, index) in conditions"
      :key="key(index)"
      class="card-condition mb-5"
      color="secondary"
      outlined
      min-width="100%"
    >
      <v-card-title class="ml-3">
        Condition {{ index + 1 }}
        <v-spacer />
        <v-btn icon @click="removeCondition(index)">
          <v-icon> delete </v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <FormCondition
          :conditions="conditions"
          :condition.sync="conditions[index]"
        />
      </v-card-text>
    </v-card>
    <v-row align-content="center" justify="space-around" class="my-5">
      <v-btn :disabled="disableMultipleConditions" color="grey lighten-2" outlined border="0" x-large @click="addCondition()">
        <v-icon left>add</v-icon> Ajouter une condition
      </v-btn>
    </v-row>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue';
import moment from 'moment';
import FormCondition from './RuleForms/FormCondition.vue';
import { useStore } from 'vue2-helpers/vuex';
const store = useStore();

const props = defineProps({
  value: { type: Array, default: () => [] },
  workspaces: { type: Array, default: null },
  inCreateMode: { type: Boolean, default: null }
});

const conditions = ref(props.value || []);
const timestamp = ref(moment().unix());

const disableMultipleConditions = computed(() => store.state.environment.PROJECT === 'speedboat' && conditions.value.some(condition => condition.hasContext));
const showConditionInfo = computed(() => store.state.environment.PROJECT === 'speedboat' && conditions.value.some(condition => condition.hasContext) || conditions.value.length > 1);

const addCondition = () => {
  conditions.value.push({
    hasQuery: true,
    pattern: [],
    alternatives: false,
    filters: []
  });
};

const removeCondition = index => {
  timestamp.value = moment().unix();
  conditions.value.splice(index, 1);
};

const key = index => index + timestamp.value;

const emit = defineEmits(['input']);

watch(conditions, val => {
  // Updates v-model on the parent
  emit('input', val || null);
}, { deep: true });

onMounted(() => {
  if (props.inCreateMode) {
    addCondition();
  }
});

const tempFixReactivity = () => {
  conditions.value.forEach(condition => {
    if (!condition.hasQuery) {
      condition.pattern = [];
    }
  });
  conditions.value = JSON.parse(JSON.stringify(conditions.value));
};

tempFixReactivity();
</script>

<style>
.card-condition.v-card.secondary {
  border: 1px solid #fff !important;
}
</style>
